import React from 'react';
import { GRAPH_NAMES } from '../../../../store/dashboard/constants';
import EpfEstablishmentsButton from './components/EpfFilingDetails/EpfEstablishmentsButton';
import MsmeDelayButton from './components/MsmeDelay/MsmeDelayButton';

/** Right-aligned header action per graph; rendered by Graph outside the PDF report only. */
export const GRAPH_HEADER_ACTIONS: Record<string, React.ComponentType<{ graphData: any }>> = {
    [GRAPH_NAMES.EPF_COMPLIANCE]: EpfEstablishmentsButton,
    [GRAPH_NAMES.MSME_PAYMENT_DELAYS]: MsmeDelayButton,
};
